import React from 'react'
import { Drawer, makeStyles } from '@material-ui/core'
import Background from '../../../../providers/BackgroundProvider/Background'
import FlexRow from '../../../../components/molecules/FlexRow'
import NavIconButton from './NavIconButton'
import MobileNavbarBody from './Body'

const useStyles = makeStyles(() => ({
  mobileHeader: {
    display: 'flex',
    padding: 0,
    position: 'sticky',
    top: 0,
    left: 0,
    background: 'linear-gradient(var(--color-texture-200), transparent)',
    zIndex: 1
  }
}))

function MobileNavbarHeader () {
  const classes = useStyles()
  const [open, setOpen] = React.useState(false)

  return (
    <Background
      light='radial-gradient(circle, var(--color-texture-200), var(--color-texture-200) 85%, var(--color-texture-050))'
    >
      <div className={classes.mobileHeader}>
        <FlexRow>
          <NavIconButton icon='verticalSplit' size={32} onClick={() => setOpen(true)} style={{ backgroundColor: 'var(--color-texture-200' }} />
        </FlexRow>
      </div>
      <Drawer
        anchor='left'
        variant='temporary'
        open={open}
        onClose={() => setOpen(false)}
      >
        <MobileNavbarBody />
      </Drawer>
    </Background>
  )
}

export default MobileNavbarHeader
